import React from 'react';
import './VerifiedBox.css';
import { AiFillLock } from "react-icons/ai";
import bsc from '../../assets/bsc.png';
import eth from '../../assets/eth.png';
import sol from '../../assets/sol.png';
import arbitrum from '../../assets/arbitrum.svg';
import base from '../../assets/base.svg';
import polygon from '../../assets/polygon.svg';
import UnlistedLogo from '../../assets/unlisted-logo.png';
import avax from '../../assets/avax.webp';
import pepu from '../../assets/pepu.webp';
import robin from '../../assets/robin.svg';
import { AiOutlinePushpin } from "react-icons/ai";

const Pin = AiOutlinePushpin as unknown as React.FC<React.SVGProps<SVGSVGElement>>;

interface ProjectInterface {
  verified?: string;
  image?: string;
  chain?: string;
  title?: string;
  symbol?: string;
  countdown?: string;
  address?: string;
  round?: string;
  banner?: string;
  isad?: boolean;
  url?: string;
}

const VerifiedBox: React.FC<ProjectInterface> = (
{
  verified,
  image,
  chain,
  title,
  symbol,
  countdown,
  address,
  round,
  banner,
  isad,
  url
}
) => {

  const chainImages: { [key: string]: string } = {
    bsc: bsc,
    eth: eth,
    sol: sol,
    solana: sol,
    arbitrum: arbitrum,
    base: base,
    polygon: polygon,
    avax: avax,
    pepu: pepu,
    robin: robin
  };

  const chainLogo = chain
    ? chainImages[chain.toLowerCase()] || UnlistedLogo
    : UnlistedLogo;


  return (
    <a className={`verified-box-smaller`} target={url ? '_blank' : '_self'} href={url || `/${chain}/${address}`}>
        {banner && verified === "true" && (
          <img src={banner} className='display-banner-verified'></img>
        )}
      <div className={`verified-box-inner ${isad ? 'verified-adbox' : ''}`}>
        <div className="imagebox-verified">
          <img src={image}  className="logo-box-verified" />
          <img src={chainLogo} className='chain-image-verified' />
        </div>
        <div className="title-badge-box-verified">
          <h3>
            {title}
            {isad ? (
              <div className='pin-promoted'><Pin /> AD</div>
            ) : ''}  
          </h3>
          <div className="symbol-verified">
            {symbol}
          </div> 
          {/* <div className='risk-amount verified'>Verified</div> */}
        </div>
      </div>
    </a>
  );
};

export default VerifiedBox;
